import { X, Check } from 'lucide-react';
import { MarketingCard } from '../primitives/MarketingCard';

interface ComparisonRow {
  label: string;
  traditional: string;
  collectability: string;
}

interface ComparisonMatrixProps {
  data: ComparisonRow[];
}

/**
 * Matrix row component for comparison table
 */
function MatrixRow({
  label,
  traditional,
  collectability
}: ComparisonRow) {
  return (
    <div className="grid md:grid-cols-3 gap-4 py-4 border-b border-[#E6ECF2] last:border-0">
      <div className="font-semibold text-[#0E1325]">{label}</div>
      <div className="flex items-start gap-2 text-[15px] text-[#5F6B7A]">
        <X className="w-4 h-4 text-[#FF6B6B] flex-shrink-0 mt-0.5" />
        <span>{traditional}</span>
      </div>
      <div className="flex items-start gap-2 text-[15px] text-[#0E1325]">
        <Check className="w-4 h-4 text-[#25C281] flex-shrink-0 mt-0.5" />
        <span>{collectability}</span>
      </div>
    </div>
  );
}

/**
 * Comparison matrix component for showing traditional vs CollectABILITY features
 *
 * @example
 * <ComparisonMatrix
 *   data={[
 *     {
 *       label: 'Contact quality',
 *       traditional: 'Exists? maybe.',
 *       collectability: 'Validated primaries ranked for reach.'
 *     }
 *   ]}
 * />
 */
export function ComparisonMatrix({ data }: ComparisonMatrixProps) {
  return (
    <MarketingCard className="p-8">
      <div className="grid md:grid-cols-3 gap-4 mb-4 pb-4 border-b border-[#E6ECF2]">
        <div className="font-semibold text-[#0E1325]"></div>
        <div className="font-semibold text-[#5F6B7A] text-center">Traditional</div>
        <div className="flex items-center justify-center">
          <img
            src="/linear-logo-sm.png"
            alt="CollectABILITY"
            className="h-6"
            loading="lazy"
            height="24"
          />
        </div>
      </div>

      {data.map((row, index) => (
        <MatrixRow key={index} {...row} />
      ))}
    </MarketingCard>
  );
}
